<template>
    <modal size="lg" class="SchoolLessonShowModal" @close="close">
        <div class="embed-responsive embed-responsive-16by9">
            <iframe
                class="responsive-item"
                :src="'https://www.youtube.com/embed/' + lesson.youtube_id + '?rel=0&showinfo=0'"
                frameborder="0"
                allow="autoplay; encrypted-media"
                allowfullscreen
            ></iframe>
        </div>

        <div class="bg-body p-lg">
            <div class="flex v-center">
                <img
                    :src="lesson.instructor.profile_photo_url"
                    class="spark-profile-photo-lg m-r-lg"
                    :alt="lesson.instructor.name"
                />
                <div class="flex-1">
                    <h3 v-text="lesson.instructor.name"></h3>
                    <div
                        v-for="(channel, index) in lesson.instructor.channels.filter(
                            channel => channel.resource_name !== 'betterhype'
                        )"
                        :key="index"
                        class="SchoolLessonShowModal__instructor-channel inline-block m-r-md text-lighter"
                    >
                        <platform-icon :platform="channel.platform"></platform-icon>
                        <a :href="channel.resource_url" target="_blank">
                            <span class="SchoolLessonShowModal__instructor-channel__name">{{
                                channel.resource_name
                            }}</span>
                        </a>
                    </div>
                </div>
            </div>
        </div>

        <div class="p-lg p-b-none -m-b-lg relative">
            <h3 class="m-b-lg m-t-sm">
                {{ lesson.title }}
            </h3>

            <text-block :value="lesson.description" class="m-b-lg"></text-block>
        </div>
    </modal>
</template>
<style lang="less" type="text/less">
@import '~dashboard-less/variables';
@import '~dashboard-less/spark/utilities';

.SchoolLessonShowModal__instructor-channel {
    font-size: 16px;

    a,
    a:link,
    a:visited,
    a:hover {
        .text-lighter;
    }
}

.SchoolLessonShowModal__lesson-platform {
    font-size: 30px;
    bottom: -5px;
    right: 15px;
}
</style>
<script type="text/babel">
export default {
    props: ['lesson'],

    methods: {
        close() {
            this.$emit('close')
        },
    },
}
</script>
